import React from "react"
import { IconProps } from "./iconTypes"

const IconInfo = ({
  size = 24,
  flexible = false,
  className,
  color,
  ...props
}: IconProps) => (
  <svg
    {...props}
    viewBox="0 0 6 15"
    width={flexible ? undefined : size}
    height={flexible ? undefined : size}
    fill={color}
    className={`icon ${className ? className : ""}`}
  >
   <path d="M1.5 1.49994C1.5 1.10211 1.65804 0.720583 1.93934 0.439279C2.22064 0.157974 2.60218 -6.10352e-05 3 -6.10352e-05C3.39782 -6.10352e-05 3.77936 0.157974 4.06066 0.439279C4.34196 0.720583 4.5 1.10211 4.5 1.49994C4.5 1.89776 4.34196 2.27929 4.06066 2.5606C3.77936 2.8419 3.39782 2.99994 3 2.99994C2.60218 2.99994 2.22064 2.8419 1.93934 2.5606C1.65804 2.27929 1.5 1.89776 1.5 1.49994ZM0 5.99994C0 5.44681 0.446875 4.99994 1 4.99994H3C3.55312 4.99994 4 5.44681 4 5.99994V12.9999H5C5.55312 12.9999 6 13.4468 6 13.9999C6 14.5531 5.55312 14.9999 5 14.9999H1C0.446875 14.9999 0 14.5531 0 13.9999C0 13.4468 0.446875 12.9999 1 12.9999H2V6.99994H1C0.446875 6.99994 0 6.55306 0 5.99994Z"/>
  </svg>
)

export default IconInfo

